import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import { buttonsStyles } from './buttons-styles';
import { thumbnailStyles } from './thumbnail-styles';

import ButtonsStyleItem
  from 'components/dashboard/appearance-content/ButtonsStyleItem';
import ButtonThumbnailStyleItem
  from 'components/dashboard/appearance-content/ButtonThumbnailStyleItem';

import './ButtonsStyleSelector.css';


class ButtonsStyleSelector extends Component {
  static propTypes = {
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
    me: PropTypes.object,
  }

  static defaultProps = {
    me: null,
  }

  state = {
    currentStyle: null,
    currentButtonColor: null,
    currentFontColor: null,
    currentBorderColor: null,
    currentButtonFontColor: null,
    currentThumbnailStyle: null,
  };

  componentDidMount() {
    const { me } = this.props;
    if (me && me.custom_theme) {
      this.setState({
        currentStyle: me.custom_theme.button_style,
        currentButtonColor: me.custom_theme.button_color,
        currentFontColor: me.custom_theme.font_color,
        currentBorderColor: me.custom_theme.button_border_color,
        currentButtonFontColor: me.custom_theme.button_font_color,
        currentThumbnailStyle: me.custom_theme.button_thumbnail_style,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.me && this.props.me.custom_theme &&
      this.props.me.custom_theme != prevProps.me.custom_theme
    ) {
      this.setState({
        currentStyle: this.props.me.custom_theme.button_style,
        currentButtonColor: this.props.me.custom_theme.button_color,
        currentFontColor: this.props.me.custom_theme.font_color,
        currentBorderColor: this.props.me.custom_theme.button_border_color,
        currentButtonFontColor: this.props.me.custom_theme.button_font_color,
        currentThumbnailStyle: this.props.me.custom_theme.button_thumbnail_style,
      });
    }
  }

  onPatchCustomTheme = (parameter, value) => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const form = new FormData();
    form.append(parameter, value);
    this.props.patchCustomTheme(customThemeId, form);
  };

  onLinkBackgroundColorChange = color => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchCustomTheme('button_color', rgba);
    this.setState({ currentButtonColor: rgba });
  };

  onLinkBorderColorChange = color => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchCustomTheme('button_border_color', rgba);
    this.setState({ currentBorderColor: rgba });
  };

  onLinkButtonFontColorChange = color => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchCustomTheme('button_font_color', rgba);
    this.setState({ currentButtonFontColor: rgba });
  };

  onLinkFontColorChange = color => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    const { r, g, b, a } = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.onPatchCustomTheme('font_color', rgba);
    this.setState({ currentFontColor: rgba });
  };

  onButtonSelectorChange = item => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    this.onPatchCustomTheme('button_style', item);
    this.setState({ currentStyle: item });
  };

  onThumbnailStyleChange = item => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    this.onPatchCustomTheme('button_thumbnail_style', item);
    this.setState({ currentThumbnailStyle: item });
  };

  render() {
    const { me } = this.props;
    const isLinkBackgroundColorAvailable = me && me.custom_theme &&
      ![
        'button-style-06',
        'button-style-07',
        'button-style-08',
        'button-style-09',
        'button-style-10',
      ].includes(me.custom_theme.button_style);
    const isLinkBorderColorAvailable = me && me.custom_theme &&
      ![
        'button-style-01',
        'button-style-02',
        'button-style-03',
        'button-style-04',
      ].includes(me.custom_theme.button_style);

    return (
      <Translation>
        {(t) => (
          <div className="buttons-style-selector__component">
            {/* Buttons Style Wrapper */}
            <div className="button-styles-wrapper">
              <div className="title">{t("Button Styles")}</div>
              <div className="button-styles-list">
                {buttonsStyles && buttonsStyles.map(item => (
                  <ButtonsStyleItem
                    key={`buttons_style_key_${item}`}
                    buttonType={item}
                    active={item === this.state.currentStyle}
                    onClick={() => this.onButtonSelectorChange(item) }
                  />
                ))}
              </div>
            </div>

            {/* Thumbnail Styles */}
            <div className="thumbnail-styles-wrapper">
              <div className="title">{t("Button Icon Styles")}</div>
              <div className="styles-list">
                {thumbnailStyles && thumbnailStyles.map(item => (
                  <ButtonThumbnailStyleItem
                    key={`button-sumbnail-style-key-${item}`}
                    sumbnailType={item}
                    active={item === this.state.currentThumbnailStyle}
                    onClick={() => this.onThumbnailStyleChange(item) }
                  />
                ))}
              </div>
            </div>

            {/* Color Pickers */}
            <div className="color-pickers-wrapper">
              {/* Button Background Color */}
              {isLinkBackgroundColorAvailable &&
                <div className="section button-color">
                  <div className="title">{t("Button Background Color")}</div>
                  <ColorPicker
                    small
                    key="button_color_picker_key"
                    pickerId="button_color_picker_id"
                    color={this.state.currentButtonColor || '#bebebe'}
                    onChangeComplete={this.onLinkBackgroundColorChange}
                  />
                </div>
              }

              {/* Button Border Color */}
              {isLinkBorderColorAvailable &&
                <div className="section border-color">
                  <div className="title">{t("Button Border Color")}</div>
                  <ColorPicker
                    small
                    key="border_color_picker_key"
                    pickerId="border_color_picker_id"
                    color={this.state.currentBorderColor || '#000000'}
                    onChangeComplete={this.onLinkBorderColorChange}
                  />
                </div>
              }

              {/* Button Font Color */}
              <div className="section button-font-color">
                <div className="title">{t("Button Font Color")}</div>
                <ColorPicker
                  small
                  key="button-font_color_picker_key"
                  pickerId="button-font_color_picker_id"
                  color={this.state.currentButtonFontColor || '#000000'}
                  onChangeComplete={this.onLinkButtonFontColorChange}
                />
              </div>

              {/* Title & Description Font Color */}
              {(me.description || !me.username_is_hidden) &&
                <div className="section title-font-color">
                  <div className="title">{t("Title & Description Font Color")}</div>
                  <ColorPicker
                    small
                    key="title-description-font_color_picker_key"
                    pickerId="title-description-font_color_picker_id"
                    color={this.state.currentFontColor || '#000000'}
                    onChangeComplete={this.onLinkFontColorChange}
                  />
                </div>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(ButtonsStyleSelector);
